var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "add-viaFtp-cont-body" }, [
        _c("div", [
          _c("span", {
            staticClass: "add-ftp-des",
            staticStyle: { position: "relative", left: "-5Px" },
            domProps: {
              innerHTML: _vm._s(
                _vm.$t("language.popup.addCloudPopup.addNasFtpDes")
              )
            }
          })
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "ftp-input-line" },
          [
            _c("font", { staticClass: "cloud-viaWeb-name" }, [
              _vm._v(_vm._s(_vm.$t("language.popup.addCloudPopup.displayName")))
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.displayName,
                  expression: "displayName"
                }
              ],
              staticClass: "via-ftp-input",
              style: { width: this.$i18n.locale == "italian" ? "450Px" : "" },
              attrs: { type: "text", name: "" },
              domProps: { value: _vm.displayName },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.displayName = $event.target.value
                }
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "ftp-input-line" },
          [
            _c("font", { staticClass: "cloud-viaWeb-name" }, [
              _vm._v(_vm._s(_vm.$t("language.popup.addCloudPopup.server")))
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "question-mark",
                staticStyle: { float: "right", position: "absolute" }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "icon-util question",
                    attrs: { id: "viaFtp" }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "via-ftp-explanation" },
                      [
                        _c("font", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t("language.popup.addCloudPopup.explanation")
                            )
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.port,
                  expression: "port"
                }
              ],
              staticClass: "ftp-cont-right-one",
              attrs: { type: "text" },
              domProps: { value: _vm.port },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.port = $event.target.value
                }
              }
            }),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.httpName,
                  expression: "httpName"
                }
              ],
              staticClass: "ftp-cont-input",
              style: { width: this.$i18n.locale == "italian" ? "260Px" : "" },
              attrs: { type: "text" },
              domProps: { value: _vm.httpName },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.httpName = $event.target.value
                }
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "ftp-input-line" },
          [
            _c("font", { staticClass: "cloud-viaWeb-name" }, [
              _vm._v(_vm._s(_vm.$t("language.popup.addCloudPopup.userName")))
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.email,
                  expression: "email"
                }
              ],
              staticClass: "ftp-cont-three",
              style: { width: this.$i18n.locale == "italian" ? "450Px" : "" },
              attrs: { type: "text" },
              domProps: { value: _vm.email },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.email = $event.target.value
                }
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "ftp-input-line" },
          [
            _c("font", { staticClass: "cloud-viaWeb-name" }, [
              _vm._v(_vm._s(_vm.$t("language.popup.addCloudPopup.passWord")))
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.password,
                  expression: "password"
                }
              ],
              staticClass: "ftp-cont-three",
              style: { width: this.$i18n.locale == "italian" ? "450Px" : "" },
              attrs: { type: "password" },
              domProps: { value: _vm.password },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.password = $event.target.value
                }
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "advanced" }, [
          _c(
            "div",
            { staticClass: "advanced-menu" },
            [
              _c(
                "font",
                {
                  staticClass: "advanced-text",
                  attrs: { id: "advancedText" },
                  on: {
                    click: function($event) {
                      return _vm.advancedDivShow()
                    }
                  }
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.advanced")) +
                      "\r\n                    "
                  ),
                  _c("div", {
                    staticClass: "icon-util folding-panel slide",
                    class: { "folding-panel-up": _vm.advancedShow },
                    attrs: { id: "iconUtil" }
                  })
                ]
              )
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "ftp-slide" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.advancedShow,
                expression: "advancedShow"
              }
            ],
            staticClass: "add-ftp-buttom",
            staticStyle: {
              "margin-left": "5Px",
              "min-width": "610Px",
              "padding-right": "25Px"
            }
          },
          [
            _c(
              "div",
              { staticClass: "advanced-item" },
              [
                _c(
                  "font",
                  {
                    staticClass: "via-advanced-name",
                    style: {
                      width: this.$i18n.locale == "italian" ? "160Px" : ""
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("language.popup.addCloudPopup.transMode"))
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticStyle: { float: "left" },
                    style: {
                      marginLeft: this.$i18n.locale == "italian" ? "-10Px" : ""
                    }
                  },
                  [
                    _c("cloud-select", {
                      attrs: {
                        selectOption: _vm.transferMode,
                        placeholder: _vm.selectModeValue
                      },
                      on: { changeOption: _vm.changeTransferMode }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "advanced-item" },
              [
                _c(
                  "font",
                  {
                    staticClass: "via-advanced-name",
                    style: {
                      width: this.$i18n.locale == "italian" ? "160Px" : ""
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("language.popup.addCloudPopup.encoding"))
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticStyle: { float: "left" },
                    style: {
                      marginLeft: this.$i18n.locale == "italian" ? "-10Px" : ""
                    }
                  },
                  [
                    _c("cloud-select", {
                      attrs: {
                        selectOption: _vm.enCoding,
                        placeholder: _vm.selectCodValue
                      },
                      on: { changeOption: _vm.onChangeCharSet }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "ftp-input-line" },
              [
                _c("font", { staticClass: "cloud-viaWeb-name" }, [
                  _vm._v(_vm._s(_vm.$t("language.popup.addCloudPopup.path")))
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.path,
                      expression: "path"
                    }
                  ],
                  staticClass: "ftp-cont-three",
                  class: _vm.advancedShow && !_vm.SftpShow ? "path-input" : "",
                  style: {
                    width: this.$i18n.locale == "italian" ? "450Px" : ""
                  },
                  attrs: { type: "text" },
                  domProps: { value: _vm.path },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.path = $event.target.value
                    }
                  }
                })
              ],
              1
            )
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3ce9ddab", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ce9ddab","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/tabs/tabs_add_cloud/tab_via_ftp.vue
// module id = null
// module chunks = 